import {
  Level_INFO_getInstance1jaw01kotd0ox as Level_INFO_getInstance,
  Level_ERROR_getInstance8a6cbaqpnh7n as Level_ERROR_getInstance,
} from './Level.mjs';
import { toStringSafe207d7m7lap1sq as toStringSafe } from './internal/MessageInvoker.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function info(message) {
  return this.w2h(null, null, message);
}
function info_0(throwable, message) {
  return this.w2h(null, throwable, message);
}
function info_1(marker, throwable, message) {
  var tmp = Level_INFO_getInstance();
  return this.d2i(tmp, marker, ($this$at) => {
    $this$at.y2h_1 = toStringSafe(message);
    $this$at.z2h_1 = throwable;
    return Unit_instance;
  });
}
function error(throwable, message) {
  return this.f2i(null, throwable, message);
}
function error_0(marker, throwable, message) {
  var tmp = Level_ERROR_getInstance();
  return this.d2i(tmp, marker, ($this$at) => {
    $this$at.y2h_1 = toStringSafe(message);
    $this$at.z2h_1 = throwable;
    return Unit_instance;
  });
}
var KLoggerClass;
function KLogger() {
  if (KLoggerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KLogger');
    KLoggerClass = $;
  }
  return KLoggerClass;
}
//region block: exports
export {
  error as error12wpw0xi3o0bs,
  error_0 as error1aa4zvb3h0fa3,
  info_1 as info2wxw456lwpd2r,
  info_0 as info2hxv79dt541ps,
  info as info3uezdutu3rpr2,
  KLogger as KLogger368y32iihya1v,
};
//endregion

//# sourceMappingURL=KLogger.mjs.map
